import type { TaggableEntityType } from '@speles7172/file-console';

/**
 * The record types a file may be tagged to.
 *
 * Kept beside the components rather than inline in each, so the Files page and
 * every embedded explorer offer the same set — a file taggable to a venue on
 * one screen and not the next reads as a bug.
 *
 * The strings are the entity types the backend directory answers for
 * (`src/files/directory.ts`). A type named here that it does not know would
 * draw a picker whose search returns nothing, so the two lists move together.
 *
 * ⚠️ **Lower case, and not by preference — the package's grammar requires it.**
 * These reach `GET /files/entities` and go straight to `assertEntityType`, which
 * refuses anything outside `/^[a-z][a-z0-9_-]*$/` so that no separator or case
 * fold can mean two things. They read `'EVENT'` until now, which is the exact
 * fault `src/files/directory.ts` records having fixed on its own side: every
 * node id it produced was invalid and browsing into a record answered 500. Here
 * it was narrower and quieter — the tag picker in the file details dialog
 * refusing every search — and it only became reachable when the Files page
 * started rendering the console that draws it.
 */
export const FILE_ENTITY_TYPES: readonly TaggableEntityType[] = [
  { entityType: 'event', label: 'Event' },
  { entityType: 'vendor', label: 'Vendor' },
  { entityType: 'venue', label: 'Venue' },
];
